import { Box, Skeleton } from '@mui/material'
import { APIError } from 'components/core/errors/api'
import { GetStepUpProviderRequest } from 'pbts/c1/api/stepup/v1/stepup'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { getStepUpProviderApi } from 'redux_toolkit/step-up-providers'
import { StepUpProviderDisplay, StepUpProviderDisplayProps } from './StepUpProviderDisplay'

/**
 * Props for the StepUpProviderFetcher component
 */
export interface StepUpProviderFetcherProps extends Omit<StepUpProviderDisplayProps, 'provider'> {
    /**
     * The ID of the Step Up Provider to fetch
     */
    providerId: string
}

/**
 * Fetches and displays a Step Up Provider
 */
export const StepUpProviderFetcher: FC<StepUpProviderFetcherProps> = ({
    providerId,
    ...displayProps
}) => {
    const { data: response, error, isLoading } = getStepUpProviderApi.useGet(
        GetStepUpProviderRequest.create({
            id: providerId,
        }),
    )

    if (isLoading) {
        return <Skeleton variant="rectangular" width="200px" height={24} />
    }

    if (error) {
        return <APIError err={error} />
    }

    if (!response?.stepUpProvider) {
        return (
            <Box sx={{ color: 'text.secondary' }}>
                <FormattedMessage
                    id="component_step_up_provider_not_found"
                    defaultMessage="Provider not found"
                />
            </Box>
        )
    }

    return <StepUpProviderDisplay provider={response.stepUpProvider} {...displayProps} />
}
